export default {
    namespaced: true,
    state: {
        // 主题设置
        isMobile: false,
        theme: "light",
        layout: "side",
        multipage: true,
        // 网站设置
        systemName: "万药城",
        copyright: "2024 yunlianshikang.com 成都云联世康科技有限公司 版权所有\n蜀ICP备2024010001号-1"
    },
    mutations: {
        setDevice(state, isMobile) {
            state.isMobile = isMobile;
        },
        setTheme(state, theme) {
            state.theme = theme;
        },
        setLayout(state, layout) {
            state.layout = layout;
        },
        setMultipage(state, multipage) {
            state.multipage = multipage;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/setting.js